module.exports = __webpack_public_path__ + "img/login-bgc.644fc490.jpeg";